import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import TopHeader from "./component/header/topheader";
import BottomHeader from "./component/header/bottomheader";
import Homepage from "./pages/home";
import Footer from "./component/footer/footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import EzyMpspage from "./pages/ezympspage";
import Manufacturing from "./pages/manufacture";
import ExportImport from "./pages/exportimport";
import Trading from "./pages/trading";

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <Router>
      <div className="App">
        <TopHeader />
        <BottomHeader />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/smart-manufacturing" element={<Manufacturing />} />
          <Route path="/ezymps-page" element={<EzyMpspage />} />
          <Route path="/export-import" element={<ExportImport />} />
          <Route path="/innovative-trading" element={<Trading />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
